import React, { useState } from 'react';
import { Button, Icon, Dropdown, Tree, SplitButton, CnButton, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { getItem } from '@/common/manager/filter-item';
import { handleComponentTitle, handleI18nLabel, } from '@/common/util/util';
export const AddOneBtn = (props) => {
    const { position } = props || {};
    const [visible, setVisible] = useState(false);
    const [selectList, setSelectList] = useState([]);
    const nodeData = [];
    const { onAdd, prop } = props;
    const nodesMap = prop.getNode?.()?.document?.nodesMap;
    const currentId = prop?.getNode?.()?.id;
    if (nodesMap?.forEach) {
        nodesMap.forEach((item) => {
            const { id } = item;
            if (item?.getPropValue('isCnTable')) {
                const columns = item.getPropValue('columns') || [];
                if (columns?.length > 0) {
                    const realName = item?.propsData?.tableName;
                    const temp = {
                        label: `表格_${realName || id.replace('node', '')}`,
                        key: id,
                        children: [],
                    };
                    columns.forEach((column) => {
                        let { title, dataIndex } = column;
                        title = handleI18nLabel(title);
                        if (title && dataIndex) {
                            temp.children.push({
                                label: `${title}(${dataIndex})`,
                                key: `${id}_${dataIndex}`,
                                originValue: dataIndex,
                                originLabel: title,
                                originConfig: column,
                                parentComponent: item.componentName,
                            });
                        }
                    });
                    if (temp.children.length > 0) {
                        nodeData.unshift(temp);
                    }
                }
            }
            else if (item.componentName === 'CnFilter' ||
                item.componentName === 'CnForm' ||
                item.componentName === 'CnFormDialog') {
                if (item.id !== currentId) {
                    const config = item.getPropValue('config') || [];
                    let tempName = '筛选栏';
                    if (item.componentName === 'CnFormDialog') {
                        tempName = '表单弹窗';
                    }
                    else if (item.componentName === 'CnForm') {
                        tempName = '表单';
                    }
                    let comName = tempName + id.replace('node', '');
                    if (item?.propsData?.title) {
                        comName = `${tempName}_${handleComponentTitle(item?.propsData?.title)}`;
                    }
                    const temp = {
                        label: comName,
                        key: id,
                        children: [],
                    };
                    if (config?.length > 0) {
                        config.forEach((con) => {
                            let { label, name, componentName } = con;
                            label = handleI18nLabel(label);
                            if (name) {
                                const tempItem = {
                                    label: `${label}(${name})`,
                                    key: `${id}_${name}`,
                                    originValue: name,
                                    originLabel: label,
                                    originConfig: con,
                                    parentComponent: item.componentName,
                                };
                                if (componentName) {
                                    tempItem.componentName = componentName;
                                }
                                temp.children.push(tempItem);
                            }
                        });
                        if (temp.children.length > 0) {
                            nodeData.push(temp);
                        }
                    }
                }
            }
        });
    }
    const select = (selectedKeys, extra = {}) => {
        const { checkedNodes = [] } = extra;
        const result = [];
        checkedNodes.forEach((item) => {
            const { props } = item;
            const { originLabel, originValue, componentName, originConfig, parentComponent, } = props;
            if (originValue) {
                result.push({
                    label: originLabel,
                    name: originValue,
                    componentName,
                    config: originConfig,
                    parentComponent,
                });
            }
        });
        setSelectList(result);
    };
    const getNewList = () => {
        const result = [];
        const currentComponent = props?.prop?.getNode?.()?.componentName;
        if (selectList?.length > 0) {
            selectList.forEach((item) => {
                if (item) {
                    const { label, name, componentName, parentComponent } = item;
                    let newItem = {};
                    if (parentComponent === currentComponent) {
                        newItem = { ...item.config };
                    }
                    else if (currentComponent === 'CnFilter' ||
                        currentComponent === 'CnForm' ||
                        currentComponent === 'CnFormDialog') {
                        newItem.label = label;
                        newItem.name = name;
                        newItem.componentName = componentName;
                    }
                    let component;
                    if (currentComponent === 'CnFilter') {
                        component = getItem(DisplayPosition.filter, componentName);
                    }
                    else if (currentComponent === 'CnForm') {
                        component = getItem(DisplayPosition.form, componentName);
                    }
                    else if (currentComponent === 'CnFormDialog') {
                        component = getItem(DisplayPosition.formDialog, componentName);
                    }
                    if (!component) {
                        newItem.componentName = 'Input';
                    }
                    result.push(newItem);
                }
            });
        }
        return result;
    };
    const addInsert = () => {
        const result = getNewList();
        const existConfig = props?.prop?.getValue() || [];
        const existMap = {};
        existConfig.forEach((item) => {
            if (item.name) {
                existMap[item.name] = true;
            }
        });
        const toAddList = [...existConfig];
        if (result?.length > 0) {
            result.forEach((item) => {
                const { name } = item;
                if (!existMap[name]) {
                    toAddList.push(item);
                }
            });
            if (toAddList.length > 0) {
                props?.prop?.setValue(toAddList);
                const sel = window?.AliLowCodeEngine?.project?.currentDocument?.selection;
                if (sel) {
                    sel?.select?.();
                    setTimeout(() => {
                        sel?.select?.(currentId);
                    });
                }
            }
        }
        setVisible(false);
    };
    const allInsert = () => {
        const result = getNewList();
        const existConfig = props?.prop?.getValue() || [];
        const existMap = {};
        existConfig.forEach((item) => {
            if (item.name) {
                existMap[item.name] = true;
            }
        });
        if (result.length > 0) {
            props?.prop?.setValue(result);
            const sel = window?.AliLowCodeEngine?.project?.currentDocument?.selection;
            if (sel) {
                sel?.select?.();
                setTimeout(() => {
                    sel?.select?.(currentId);
                });
            }
        }
        setVisible(false);
    };
    let addButton = (<CnButton onClick={() => onAdd?.()} type={'primary'} style={{ flex: 1, marginRight: '6px' }}>
      添加一项
    </CnButton>);
    if (position === DisplayPosition.form) {
        addButton = (<SplitButton leftButtonProps={{
                style: {
                    width: 'calc(100% - 36px)',
                },
            }} popupTriggerType={'hover'} label={'添加一项'} onClick={() => onAdd?.()} onItemClick={(key) => {
                window.__lowcode_form_current_add_componentName__ = key;
                onAdd?.();
            }} type={'primary'} style={{ flex: 1 }}>
        <SplitButton.Item key={'CnCard'}>快速添加卡片</SplitButton.Item>
        <SplitButton.Item key={'CnCardSubCard'}>
          快速添加子卡片
        </SplitButton.Item>
      </SplitButton>);
    }
    return (<div style={{ width: '100%', display: 'flex' }}>
      {addButton}
      <Dropdown style={{ flex: 1 }} visible={visible} onVisibleChange={(visible) => {
            setVisible(visible);
        }} trigger={<Button type={'primary'}>
            选择已有
            <Icon type={'arrow-down'}/>
          </Button>} triggerType={['click']}>
        <div style={{
            background: '#fff',
            padding: '12px',
            border: '1px solid #ddd',
            borderRadius: '3px',
        }}>
          <div style={{
            maxHeight: '300px',
            overflow: 'auto',
        }}>
            <Tree selectable={false} isNodeBlock onCheck={select} defaultExpandAll checkable dataSource={nodeData}/>
          </div>
          <div style={{
            paddingTop: '10px',
            borderTop: '1px solid #ddd',
            display: 'flex',
            justifyContent: 'flex-end',
        }}>
            <Button size={'small'} onClick={() => {
            setVisible(false);
        }}>
              取消
            </Button>
            &nbsp;&nbsp;
            <Button size={'small'} type={'secondary'} onClick={allInsert}>
              覆盖导入
            </Button>
            &nbsp;&nbsp;
            <Button size={'small'} type={'secondary'} onClick={addInsert}>
              增量导入
            </Button>
          </div>
        </div>
      </Dropdown>
    </div>);
};
